import * as S from "../TaskCardFirstSteps/taskCardContentsFirstSteps.styles";
import { ReactComponent as IconGPS } from "../../../../styles/assets/svg/icon-gps.svg";
import { ReactComponent as IconLeft } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRight } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { ReactComponent as IconCameraWhite } from "../../../../styles/assets/svg/icon-camera-white.svg";
import { ReactComponent as IconReceipt } from "../../../../styles/assets/svg/icon-receipt.svg";
import { TaskCardContentStepsProps } from "../TaskCardFirstSteps";
import {
  Transportation,
  TransportationType,
} from "../../../../interface/transportation";
import dayjs from "dayjs";

interface TaskCardContentThirdProps extends TaskCardContentStepsProps {
  workPointData?: TransportationType;
  handleNextButtonClick: () => void;
  handleBackBtnClick: () => void;
  onImageRegisterPageMove: () => void;
  onInvoiceImageRegisterPageMove?: () => void;
}

export const TaskCardContentsThirdSteps = ({
  handleNextButtonClick,
  handleBackBtnClick,
  onImageRegisterPageMove,
  onInvoiceImageRegisterPageMove,
  workPointData,
}: TaskCardContentThirdProps) => {
  return (
    <S.TaskBox>
      <S.TaskTotalWrapContainer>
        {workPointData?.transport_type === 1 && (
          <S.TaskTotalWrap onClick={onInvoiceImageRegisterPageMove}>
            <IconReceipt width={25} height={25} /> 인수증
          </S.TaskTotalWrap>
        )}
        <S.TaskTotalWrap onClick={onImageRegisterPageMove}>
          <IconCameraWhite width={25} height={25} /> 사진등록
        </S.TaskTotalWrap>
      </S.TaskTotalWrapContainer>
      <S.TaskContainer>
        <S.TaskContent>
          <S.TaskHeadBox>
            <S.Sbox>
              <S.StepBox>3 / 6단계</S.StepBox>
              <S.StateBox>작업지 이동</S.StateBox>
            </S.Sbox>
            <S.DateBox>
              {dayjs(new Date()).format("YYYY-MM-DD HH:mm")}
            </S.DateBox>
          </S.TaskHeadBox>
          <S.ProgressBar progress="51%" />

          <S.LocationBox>
            <IconGPS />
            <S.AreaBox>
              {workPointData?.work_place_name}
              <span>{workPointData?.work_place_address}</span>
            </S.AreaBox>
          </S.LocationBox>

          <S.DetailContents>
            <S.ContainerBox>
              <S.TableHeader>컨테이너 규격</S.TableHeader>
              <S.TableCell>{workPointData?.container_spec}</S.TableCell>
            </S.ContainerBox>
            {/* <S.ContainerBox>
            <S.TableHeader>컨테이너 번호</S.TableHeader>
            <S.TableCell>
              {loadingPointData?.loadingPoint?.containerType}
            </S.TableCell>
          </S.ContainerBox> */}
            <S.ContainerBox>
              <S.TableHeader>전화번호</S.TableHeader>
              <S.TableCell>{workPointData?.work_place_tel}</S.TableCell>
            </S.ContainerBox>
          </S.DetailContents>

          {/* <S.DetailContents>
          <S.ContainerBox>
            <S.TableHeader>작업지명</S.TableHeader>
            <S.TableCell>{workPointData?.workPoint?.companyName}</S.TableCell>
          </S.ContainerBox>
          <S.ContainerBox>
            <S.TableHeader>전화번호</S.TableHeader>
            <S.TableCell>
              {workPointData?.workPoint?.companyPhoneNumber}
            </S.TableCell>
          </S.ContainerBox>
        </S.DetailContents> */}
        </S.TaskContent>
        <S.ButtonBox>
          <S.Button width="60%" color="white" onClick={handleBackBtnClick}>
            <IconLeft width={20} height={20} />
            <S.BText>이전</S.BText>
          </S.Button>
          <S.Button
            width="100%"
            color="primary"
            isErrorCheck={true}
            onClick={handleNextButtonClick}
          >
            <S.BText>다음</S.BText>
            <IconRight width={20} height={20} />
          </S.Button>
        </S.ButtonBox>
      </S.TaskContainer>
    </S.TaskBox>
  );
};
export default TaskCardContentsThirdSteps;
